import { Cohort } from '@dtx-company/true-common/src/types/cohorts'
import { DEFAULT_COHORT } from '@dtx-company/true-common/src/constants/cohorts'
import { useAuthState } from '../useAuthState'

/**
 * For logged in users, wait for `isAuthChecked` and then this will be
 * their cohort.
 *
 * For logged out users, this pulls from what they were assigned in Optimizely
 * or provides the current `DEFAULT_COHORT`.
 *
 * Can be used to assign the initial cohort on signup, show cohort limits,
 * and log the cohort name to heap with any events that are interested in it.
 */
export function useCohort(isDefaultCohort?: boolean): Cohort {
  const { cohort } = useAuthState()
  if (isDefaultCohort) return DEFAULT_COHORT
  if (cohort) return cohort
  return DEFAULT_COHORT
}
